/**
 * @generated SignedSource<<84a96455ea5447daccf1df6cfa659f9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EstimatedValue_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item" | "useGetEstimatedValueRange_item" | "useShowPricingGuidance_item">;
  readonly " $fragmentType": "EstimatedValue_item";
};
export type EstimatedValue_item$key = {
  readonly " $data"?: EstimatedValue_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"EstimatedValue_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EstimatedValue_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetEstimatedValueRange_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0037d3854a36f74e786f98823ef689a7";

export default node;
